/**
 * StoreListContainer
 * --
 */
import React from 'react';
import StoreListPresenter from './StoreListPresenter';

const StoreListContainer = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <>
      <StoreListPresenter />
    </>
  );
};

export default StoreListContainer;
